import { StateProvider } from "../lib/store";
import { lazy, Suspense } from "react";

const CascadeLayout = lazy(() => import("./cascade/layout"));
const RollinsLayout = lazy(() => import("./layout/rollins-layout"));
const CampaignLayout = lazy(() => import("./campaign/campaign-layout"));

function Layout({
  location,
  children,
  cssClass,
  page,
  section,
  banners,
  props,
  isNews,
  title,
  isNewsPost,
  isTopic,
  noTopics,
  noNav
}) {
  if (section?.theme?.themeComponent) {
    const themes = new Map([
      ["CascadeLayout", CascadeLayout],
      ["RollinsLayout", RollinsLayout],
      ["CampaignLayout", CampaignLayout],
      ["GraduateStudiesLayout", RollinsLayout],
      ["ContinuingStudiesLayout", RollinsLayout],
      ["data", CascadeLayout],
    ]);
    const PageSectionLayout = themes.get(section.theme.themeComponent);
    return (
        <StateProvider>
          <Suspense fallback={null}>
            <PageSectionLayout
              type={section.theme.themeComponent}
              title={title}
              section={section}
              isNews={isNews}
              isNewsPost={isNewsPost}
              isTopic={isTopic}
              noTopics={noTopics}
              location={location}
              children={children}
              cssClass={cssClass}
              page={page}
              banners={banners}
              noNav={noNav}
            />
          </Suspense>
        </StateProvider>
    );
  }

  if (location !== undefined) {
    const newsTemplates = new Map([
      ["college-of-liberal-arts", RollinsLayout],
      ["graduate", RollinsLayout],
      ["professional-advancement", RollinsLayout],
      ["news", CascadeLayout],
      ["brightertogether", CampaignLayout],
    ]);
    const NewsSectionLayout = newsTemplates.get(
      location.pathname.split("/")[1]
    );

    return (
        <StateProvider>
          <Suspense fallback={null}>
            <NewsSectionLayout
              title={title}
              section={section}
              isNews={isNews}
              isNewsPost={isNewsPost}
              isTopic={isTopic}
              noTopics={noTopics}
              location={location}
              children={children}
              cssClass={cssClass}
              page={page}
              banners={banners}
              noNav={noNav}
            />
          </Suspense>
        </StateProvider>
    );
  }

  return (
    <StateProvider>
      <RollinsLayout
        title={title}
        section={section}
        isNews={isNews}
        isNewsPost={isNewsPost}
        isTopic={isTopic}
        noTopics={noTopics}
        location={location}
        children={children}
        cssClass={cssClass}
        page={page}
        banners={banners}
        noNav={noNav}
      />
    </StateProvider>
  );
}

export default Layout;
